import { SlideClassification } from "pwapi";

import {
  LESION_LINE_TYPES,
  LesionLine,
  lesionLineTypeByName,
} from "shared/reducers/aiReducer";

const segregateByResult = (
  aiObject: SlideClassification,
  diagnosis_result: string
) =>
  aiObject.lesion_lines
    ?.filter((e) => e.diagnosis_result === diagnosis_result)
    ?.sort((a, b) => b.wsi_lvl_prediction - a.wsi_lvl_prediction)
    ?.map((e) => lesionLineTypeByName(e.diagnosis_name)) || [];

export const segregratedClassificationLines = (
  aiObject: SlideClassification
) => {
  const lesionLineByLesionLineType =
    aiObject.lesion_lines?.reduce(
      (map, e) => map.set(lesionLineTypeByName(e.diagnosis_name), e),
      new Map<string, LesionLine>()
    ) || new Map<string, LesionLine>();

  const positiveLesionLineTypes = segregateByResult(aiObject, "POSITIVE");
  const negativeLesionLineTypes = segregateByResult(aiObject, "NEGATIVE");
  const inconclusiveLesionLineTypes = [
    ...segregateByResult(aiObject, "UNDEFINED"),
    ...segregateByResult(aiObject, "INCONCLUSIVE"),
  ];

  const notRunLesionLineTypes = [
    ...new Set(
      [...lesionLineByLesionLineType.keys()].concat(
        LESION_LINE_TYPES.filter((e) => e !== "INC")
      )
    ),
  ].slice(lesionLineByLesionLineType.size);

  return {
    lesionLineByLesionLineType,
    positiveLesionLineTypes,
    negativeLesionLineTypes,
    inconclusiveLesionLineTypes,
    notRunLesionLineTypes,
  };
};
